<template>
  <div class="main-content">
    <Nav></Nav>
    <div class="center-body">
      <div class="row">
        <!-- <img src="../../assets/img/u30.png" style="width: 100%;" /> -->
        <!-- <div class="item" style="align-items: center;">
          {{ $t("lang.product") }}
          >
          {{ $t("lang.productcenter") }}
          >
          {{ $t("lang.classifylist") }} -->
        <!-- <Button @click="goback">{{ $t("lang.back") }}</Button> -->
        <!-- </div> -->
        <Breadcrumb separator=">">
          <BreadcrumbItem to="/">{{ $t("lang.product") }}</BreadcrumbItem>
          <BreadcrumbItem to="/filter">{{
            $t("lang.productcenter")
          }}</BreadcrumbItem>
          <BreadcrumbItem>{{ $t("lang.classifylist") }}</BreadcrumbItem>
        </Breadcrumb>
      </div>

      <div class="prduct-box">
        <div class="row">
          <div
            class="item"
            style="font-size: 24px;color: #333;font-weight: 400;margin:10px 0 35px;"
          >
            {{ $t("lang.classifylist") }}
          </div>
        </div>
        <!-- <div
          class="item"
          style="justify-content: flex-end;align-items: center;"
        >
          <Button @click="back">{{ $t("lang.back") }}</Button>
        </div> -->
        <div class="wrap-row" style="margin: 0 -15px 15px;">
          <div
            class="col-no"
            style="width: 23%;margin: 0 1%;margin-top: 15px;"
            v-for="list in productList"
            :key="list.id"
            @click="toDetail(list)"
          >
            <div
              style="width: 100%;height: 270px;background: #666;overflow: hidden;display: flex;justify-content: center;align-items: center;"
            >
              <img :src="list.pic" style="width: 100%;" />
            </div>
            <div
              class="item"
              style="justify-content: center;font-size: 14px;color: #333;font-weight:400;margin-top: 10px;"
            >
              {{ ztype == 1 ? list.name : list.value }}{{ proName }}
            </div>
          </div>
        </div>
      </div>

      <div class="prduct-box">
        <div class="row">
          <div
            class="item"
            style="font-size: 24px;color: #333;font-weight: 400;margin:10px 0 35px;"
          >
            {{ $t("lang.recommend") }}
          </div>
        </div>
        <div class="wrap-row" style="margin: 0 -15px 15px;">
          <div
            class="col-no"
            style="width: 23%;margin: 0 1%;margin-top: 15px;"
            v-for="rec in recomondList"
            :key="rec.id"
          >
            <div
              style="width: 100%;height: 270px;overflow: hidden;display: flex;justify-content: center;align-items: center;"
              @click="toCDetail(rec)"
            >
              <img :src="rec.pic" style="width: 100%;" />
            </div>
            <div
              class="item"
              style="justify-content: center;font-size: 14px;font-weight:400;color: #333;margin-top: 10px;"
            >
              {{ rec.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./nav.vue";
export default {
  name: "App",
  components: {
    Nav,
  },
  data() {
    return {
      protype: "",
      ztype: "",
      proName: "",
      productId: "",
      productList: [],
      recomondList: [],
    };
  },
  methods: {
    toDetail(list) {
      window.scrollTo(0,0);
      if (this.ztype === 1) {
        this.$localstorage.setStore("detail_productId", list.id);
      } else {
        this.$localstorage.setStore("detail_productId", this.productId);
        this.$localstorage.setStore("groupValue", list.value);
      }
      this.$router.push("detail");
    },
    toCDetail(list) {
      window.scrollTo(0,0)
      var u = this.$util.toRecom(list);
      if (u === "detail") {
        this.$router.push(u);
      } else {
        this.store_reload();
      }
    },
    store_reload() {
      if (this.$localstorage.getStore("duanzi")) {
        //端子
        this.protype = this.$localstorage.getStore("duanzi");
        this.ztype = 1;
        this.listDuanzi();
      } else if (this.$localstorage.getStore("protype")) {
        //扎带
        this.productId = this.$localstorage.getStore("protype");
        this.proName = this.$localstorage.getStore("proName");
        this.listPro();
      } else if (this.$localstorage.getStore("productId")) {
        this.ztype = 1;
        this.productId = this.$localstorage.getStore("productId");
        this.listProDetail();
      }
    },
    recomond() {
      var self = this;
      this.$api.api
        .xinlongComond({ productId: self.productId, width: "" })
        .then(function(response) {
          if (response.data.code == 200) {
            self.recomondList = response.data.data;
          }
        });
    },
    listDuanzi() {
      var self = this;
      this.$api.api
        .listPro({ protype: this.protype, needProperty: false })
        .then(function(response) {
          if (response.data.code === 200) {
            self.productList = response.data.data;
            self.recomond();
          } else {
            self.$toast(response.data.msg);
          }
        });
    },
    listPro() {
      var self = this;
      this.$api.api
        .listSpecialGroup({ productId: self.productId })
        .then(function(response) {
          if (response.data.code === 200) {
            self.productList = response.data.data.sort(self.sortValue);
            self.recomond();
          } else {
            self.$toast(response.data.msg);
          }
        });
    },
    listProDetail() {
      var self = this;
      this.$api.api.proDetail(self.productId)
              .then(function(response) {
                if (response.data.code === 200) {
                  self.productList = [response.data.data];
                  self.recomond();
                } else {
                  self.$toast(response.data.msg);
                }
              });
    },
    sortValue(a, b) {
      return parseFloat(a.value) - parseFloat(b.value);
    },
    back() {
      // this.route.go(-1);
      history.back();
    },
  },
  mounted() {
    this.store_reload();
  },
};
</script>

<style scoped>
.main-content {
  min-height: 100%;
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  display: block;
  position: absolute;
  margin-top: 135px;
}
.center-body {
  width: 1200px;
  margin: 30px auto 0;
}
.prduct-box {
  margin-top: 25px;
  padding: 15px 0;
}
</style>
